module.exports = {"id":"dp3_1l1q3","text":"Developing digital content","instructions":"AI systems can generate digital content without any human responsibility.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"PickOne","random":false,"options":[{"id":"dp3_1l1q3-a1","text":"False","score":1.8},{"id":"dp3_1l1q3-a2","text":"Not sure","score":0},{"id":"dp3_1l1q3-a3","text":"True","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l1q3.json
// module id = 1112
// module chunks = 41